export const colorTokens = [
  'bg-app',
  'bg-shell',
  'bg-sidebar',
  'bg-panel',
  'bg-panel-soft',
  'bg-card',
  'text-primary',
  'text-secondary',
  'border',
  'accent',
  'accent-contrast',
  'success',
  'shadow-color'
];

export const themeColors = {
  light: {
  'bg-app': '#f5f7ff',
  'bg-shell': '#ffffff',
  'bg-sidebar': '#eef2ff',
  'bg-panel': '#f3f0ff',
  'bg-panel-soft': '#e7dcff',
  'bg-card': '#ffffff',
  'text-primary': '#161a2d',
  'text-secondary': '#66708f',
  border: '#d9def0',
  accent: '#6d4aff',
  'accent-contrast': '#ffffff',
  success: '#19b36b',
  'shadow-color': '#5c49ff'
},
  dark: {
  'bg-app': '#0b1020',
  'bg-shell': '#11182d',
  'bg-sidebar': '#151d36',
  'bg-panel': '#1a2242',
  'bg-panel-soft': '#232d57',
  'bg-card': '#161f38',
  'text-primary': '#f5f7ff',
  'text-secondary': '#9aa6c7',
  border: '#2a355c',
  accent: '#7c5cff',
  'accent-contrast': '#ffffff',
  success: '#2dd483',
  'shadow-color': '#000000'
}
};